<template>
  <label class="form-radio form-inline" >
    <input
        type="radio"
        :name="name"
        :value="value"
        :checked="checked"
        :disabled="disabled"
        @input="$emit('input', $event.target.value)">
    <i class="form-icon"></i> {{label}}
  </label>
</template>

<script>
  export default {
    name: 'FormInputRadioBoolean',

    props: {
      value: [Number, String],
      checked: Boolean,
      name: String,
      label: String,
      id: String,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      inputId() {
        return `custom-field-editor-${this.id || this.label.toLowerCase()}`;
      },
      placeholderText() {
        return this.placeholder || this.label;
      },
    },
  };

</script>
